var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Component from "nuxt-class-component";
import { TsVue } from "~/plugins/TsVue";
var default_1 = (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.content = [
            {
                title: 'PC+移动应用，多端展示随时管理',
                text: [
                    "商城可视化装修：首页、专题页、广告、商品等内容，从PC到移动，想变就变；",
                    " 多种登陆选择，多端数据实时同步，随时随地进行PC、手机交易管理；",
                ],
                image: {
                    class: 'floor-image-1',
                    image: '/images/content/1.png',
                    width: '664px',
                    height: '444px'
                }
            },
            {
                image: {
                    class: 'floor-image-2',
                    image: '/images/content/2.png',
                    width: '594px',
                    height: '359px'
                },
                title: '强大电商管理和支付结算功能',
                text: [
                    '会员、商品、订单、交易、售后、物流配送等管理模块一应俱全，无缝对接；',
                    '多种主流支付方式结算选择：支付宝、微信支付等；单管理和仓储管理一体化。',
                ]
            },
            {
                title: '多种促销优惠活动打造商品爆款',
                text: [
                    '可供选择的促销形式丰富多样：一客一价，优惠券，赠品，满减送，订单返现，限时折扣，秒杀等活动方式；',
                    '打造商品爆款：为客户提供打造爆款技巧，提高商品销量。',
                ],
                image: {
                    class: 'floor-image-3',
                    type: 'image',
                    image: '/images/content/3.png',
                    width: '577px',
                    height: '359px'
                }
            },
            {
                image: {
                    class: 'floor-image-4',
                    type: 'image',
                    image: '/images/content/4.png',
                    width: '380px',
                    height: '445px'
                },
                title: '统计分析完善化，一手掌握业务进展',
                text: [
                    '各平台各模块有各自的统计分析，客户、客服、订单、商品、财务概况、库存等分析一目了然，全面洞悉掌握业务运营状况。',
                    '数据统计更清晰，工作效率有效提高',
                ]
            },
        ];
        return _this;
    }
    default_1 = __decorate([
        Component({
            components: {}
        })
    ], default_1);
    return default_1;
}(TsVue));
export default default_1;



//////////////////
// WEBPACK FOOTER
// /opt/node_modules/ts-loader?{"appendTsSuffixTo":[{}],"transpileOnly":true}!/opt/node_modules/vue-loader/lib/selector.js?type=script&index=0!./components/index/Content.vue
// module id = lULU
// module chunks = 2